/* tslint:disable:jsx-no-lambda WI:47677 */
import * as React from 'react';
import { Toggle } from 'office-ui-fabric-react/lib/Toggle';
import { observer } from 'mobx-react';

export interface DiagnosticToggleProps {
    toggleValue: boolean;
    toggleTitle: string;
    changeAction: Function;
}

export interface DiagnosticToggleState {
    isDirty: boolean;
}

@observer
export default class DiagnosticToggle extends React.Component<
    DiagnosticToggleProps,
    DiagnosticToggleState
> {
    constructor(props: DiagnosticToggleProps) {
        super(props);
        this.state = { isDirty: false };
    }

    render() {
        return (
            <Toggle
                checked={this.props.toggleValue}
                offText={`Turn on ${this.props.toggleTitle} ${
                    this.state.isDirty ? '(refresh needed)' : ''
                }`}
                onText={`Turn off ${this.props.toggleTitle} ${
                    this.state.isDirty ? '(refresh needed)' : ''
                }`}
                onChanged={value => {
                    this.props.changeAction(!this.props.toggleValue);
                    this.setState({ isDirty: !this.state.isDirty });
                }}
            />
        );
    }
}
